import React from 'react';
import { COLLEGE_LABELS, COLLEGE_COLORS } from '../../store/slices/invitationSlice';

const CollegeBadge = ({ college, size = 'md', className = '' }) => {
    if (!college) return null;

    const label = COLLEGE_LABELS[college] || college;
    const colors = COLLEGE_COLORS[college] || { bg: 'bg-gray-100', text: 'text-gray-700', border: 'border-gray-300' };

    const sizes = {
        sm: 'text-xs px-2 py-0.5',
        md: 'text-sm px-3 py-1',
        lg: 'text-base px-4 py-1.5'
    };

    return (
        <span className={`inline-flex items-center rounded-full border font-medium font-ginka ${colors.bg} ${colors.text} ${colors.border} ${sizes[size]} ${className}`}>
            {label}
        </span>
    );
};

export default CollegeBadge;
